// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"532":"c9ecbfcb35e7d93c780f","878":"a7c56a6c4ca3cf684515"}[chunkId] + ".chunk.js";
};